import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: flex;
    width: ${({ isSideBar }) => isSideBar ? 'calc(100% - 20px - 55px)' : '100%'};
    justify-content: space-between;
    align-items: ${({ isSideBar }) => isSideBar ? 'flex-start' : 'center'};
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
    color: ${COLORS.black};
    line-height: 1.3;
    flex-direction: ${({ isSideBar }) => isSideBar ? 'column' : 'row'};
    @media(max-width: 530px) {
        flex-direction: column;
        align-items: flex-start;
        padding-right: 0;
        width: calc(100vw - 20px - 55px);
    }
`;

export const Text = styled.h1`
    margin-top: 20px;
    margin-bottom: 0;
    display: block;
    font-size: 24px;
    padding-bottom: ${({ isSideBar }) => isSideBar ? '5px' : '0'};

    @media(max-width: 530px) {
        font-size: 24px;
        padding-bottom: 5px;
    }
`;

export const Price = styled.div`
    display: block;
    font-size: 24px;
    span {
        padding-left: 5px;
    }
`;
